var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Defs, LinearGradient, Stop, Rect } from 'react-native-svg';
import { checkIsPlatform } from '../../utils';
import { LILAC_200, LILAC_400 } from '../../constants';
var SvgSkeletonLoaderStrip = props => {
  var accessibilityLabelKey = checkIsPlatform('web') ? 'aria-label' : 'accessibilityLabel';
  var _props = props,
    _props$fontSize = _props.fontSize,
    fontSize = _props$fontSize === void 0 ? 24 : _props$fontSize,
    _props$color = _props.color,
    color = _props$color === void 0 ? '#292C31' : _props$color,
    testID = _props.testID,
    accessibilityLabel = _props.accessibilityLabel,
    _props$gradientType = _props.gradientType,
    gradientType = _props$gradientType === void 0 ? 'default' : _props$gradientType,
    restProps = __rest(props, ["fontSize", "color", "testID", "accessibilityLabel", "gradientType"]);
  props = Object.assign(Object.assign({
    fontSize,
    color,
    id: testID
  }, restProps), accessibilityLabel && {
    [accessibilityLabelKey]: accessibilityLabel
  });
  return _jsxs(Svg, Object.assign({
    width: fontSize,
    height: fontSize
  }, props, {
    children: [_jsx(Defs, {
      children: _jsxs(LinearGradient, Object.assign({
        id: "skeleton-loader-strip_svg__a",
        x1: 0.5,
        x2: 0.5,
        y2: 1
      }, {
        children: [_jsx(Stop, {
          stopColor: gradientType == 'lilac' ? LILAC_400 : '#ddd2fe',
          stopOpacity: 0
        }), _jsx(Stop, {
          offset: 0.516,
          stopColor: gradientType == 'lilac' ? LILAC_200 : '#ddd2fe',
          stopOpacity: 0.8
        }), _jsx(Stop, {
          offset: 1,
          stopColor: gradientType == 'lilac' ? LILAC_400 : '#ddd2fe',
          stopOpacity: 0
        })]
      }))
    }), _jsx(Rect, {
      width: "100%",
      height: "100%",
      fill: "url(#skeleton-loader-strip_svg__a)"
    })]
  }));
};
export default SvgSkeletonLoaderStrip;